import { CommonState } from "../../state";

import { BettingLimit } from "./betting-limit.model";

export namespace BettingLimitSelector {
	export const getActiveBettingLimit = (state: CommonState): BettingLimit | undefined =>
		state.bettingLimit.activeBettingLimit;

	export const getQueuedBettingLimit = (state: CommonState): BettingLimit | undefined =>
		state.bettingLimit.queuedBettingLimit;

	export const getBettingLimits = (state: CommonState): BettingLimit[] | undefined =>
		state.bettingLimit.bettingLimits;

	export const getRemainingBetLimits = (state: CommonState): BettingLimit[] | undefined =>
		state.bettingLimit.remainingBetLimits;
}
